import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=f52f15e8&"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports